<template>
  <div class="header">
    <p class="claim">Entdecke deine beruflichen Interessen</p>
  </div>
</template>

<script>
export default {
  name: 'Header',
  computed: {},
}
</script>

<style scoped>
.header {
  margin: 0 15px 40px 15px;
  text-align: center;
  color: black;
}

.logo svg {
  margin: 0 auto 25px auto;
  display: block;
}

.title,
.claim {
  margin: 0;
}

.title {
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  line-height: 42px;
  font-size: 2.2em;
}

.claim {
  font-size: 1.4em;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue